import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SearchParams } from "src/app/shared/model/searchParams";
import { UrlUtilService } from "src/app/shared/service/url-util/url-util.service";

import { CustomersRequest } from "../model/cs.model";
import { endpoints } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CustomerChooseService {
  private customer_info_url = endpoints.customer_info;
  private customers_url = endpoints.contacts;
  private contact_profile_by_ext = endpoints.contact_profile_by_ext;
  constructor(private http: HttpClient, private urlService: UrlUtilService) {}

  checkIfCustomerIsValid(customerSelected) {
    return this.http.get(`${this.customer_info_url}/${customerSelected}`);
  }

  contacts(searchParams: SearchParams, body: CustomersRequest) {
    return this.http.post<Array<any>>(
      `${this.customers_url}?${this.urlService.convertObjectToSearchParam(
        searchParams
      )}`,
      body,
      { headers: this.urlService.getDefaultHeaders() }
    );
  }

  getContactProfileByExternalId(extId: string) {
    return this.http.get(`${this.contact_profile_by_ext}/${extId}`);
  }
}
